<template>
  <div>
    <el-button type="primary" icon="plus" @click="handler.open()">
      Add Account
    </el-button>
    <el-button type="danger" icon="delete" @click="deleteAll()">
      Delete All
    </el-button>
  </div>
</template>

<script>
import { db, command, exchangeToken } from '../api.js'

export default {
  name: 'PlaidLink',
  created() {
    /* global Plaid */
    this.handler = Plaid.create({
      apiVersion: 'v2',
      clientName: 'SmartPath Plaid',
      env: 'development',
      product: ['transactions'],
      key: '82f82030fd66f81fc48d69eb46df4b',
      webhook: 'https://us-central1-pokrzyk-plaid.cloudfunctions.net/plaid',
      onSuccess: this.savePublicToken
    })
  },
  methods: {
    async savePublicToken(public_token, metadata) {
      const payload = {
        command: 'process_public_token',
        public_token,
        instituion_id: metadata.institution.institution_id,
        institution_name: metadata.institution.name
      }
      console.log(payload)
      await command(payload)
    },
    deleteAll() {
      db.ref().remove()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// PlaidLink.vue?3511a880